import React from 'react';
import { Table, TableProps } from '@otp/ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { StoreModel } from 'src/graphql/generated/graphql';
import { getTableConfig } from './config';

import styles from '../index.module.css';

type OtpTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Partial<StoreModel>[];
};

export const RestaurantsTable = ({
  className,
  data,
  options,
  ...props
}: OtpTableProps) => {
  const { t } = useTranslation();
  const tableConfig = getTableConfig(data || [], { t });

  const getRowProps = (_: any, dataIndex: number) => {
    const rowData = data[dataIndex];
    const isRowNeedAttention = rowData.isNeedAttention;

    return {
      className: clsx({ [styles.needAttentionRow]: isRowNeedAttention }),
    };
  };

  return (
    <div className={className}>
      <Table
        options={{ ...options, setRowProps: getRowProps }}
        {...props}
        data={data}
        columns={tableConfig}
      />
    </div>
  );
};
